<nav class="header navbar navbar-expand-sm sticky-top p-3 border-bottom">
	<div class="container-fluid">
		<a class="d-md-flex" (click)="onTitleClick()">
			<img ngSrc="assets\images\logo_webpatient_rgb_new.png" priority width="192" height="31" alt="webpatient"/>
		</a>
		<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#headerNav"
			aria-controls="headerNav" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse justify-content-end" id="headerNav">
			<div class="flex-column">
				<ng-container *ngIf="isLoggedIn$ |async">
					<div class="d-sm-flex justify-content-sm-end justify-items-center">
						<div class="d-flex justify-content-center align-items-center">
							<helper class="d-none d-sm-block" />
						</div>
						<div class="d-none d-sm-block vr m-2"></div>
						<button type="button" class="btn btn-link d-flex align-items-center text-decoration-none px-0 gap-2"
							tabindex="0" (click)="navigateToUserPage()" data-bs-toggle="collapse"
							data-bs-target="#headerNav">
							<span class="order-sm-first order-last">{{ username$ | async }}</span>
							<svg class="icon-md icon-primary order-sm-last order-first" aria-hidden="true">
								<use xlink:href="/assets/icons.svg#user"></use>
							</svg>
						</button>
						<div class="d-none d-sm-block vr m-2"></div>
						<div class="d-sm-block">
							<button type="button"
								class="btn btn-link d-flex align-items-center text-decoration-none px-0 gap-2" tabindex="0"
								aria-current="logout" (click)="onLogoutClick()" data-bs-toggle="collapse"
								data-bs-target="#headerNav">
								<span *transloco="let t; prefix: 'header'" class="order-sm-first order-last">{{ t("logout") }}</span>
								<svg class="icon-md icon-primary order-sm-last order-first" aria-hidden="true">
									<use xlink:href="/assets/icons.svg#icon-logout"></use>
								</svg>
							</button>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="isLoggedIn$ | async; then authorizedNav; else notAuthorizedNav" />
			</div>
		</div>
	</div>
</nav>

<ng-template #authorizedNav>
	<div class="navbar-nav float-sm-end" *transloco="let t; prefix: 'header'">
		<a class="nav-link text-decoration-none active" routerLink="/">
			{{ t("frontpage") }}
		</a>
		<a *ngIf="isPatient$ | async" class="nav-link text-decoration-none active" [href]="fogpRedirectUrl">
			{{ t("fogplink") }}
		</a>
		<ng-container *ngIf="isPatient$ | async; then patientNavLinks; else doctorNavLinks"></ng-container>
	</div>
</ng-template>

<ng-template #notAuthorizedNav>
	<div class="navbar-nav float-sm-end">
		<div class="d-flex justify-content-center align-items-center">
			<helper class="d-none d-sm-block" />
		</div>
		<div class="d-none d-sm-block vr m-2"></div>
		<div class="d-sm-block">
			<button type="button"
				class="btn btn-link text-decoration-none d-flex justify-content-center align-items-center px-0 gap-2"
				(click)="onLoginClick()" tabindex="0">
				<span *transloco="let t; prefix: 'header'" class="order-sm-first order-last">{{ t("logintext") }}</span>
				<svg class="icon-md icon-primary order-sm-last order-first" aria-hidden="true">
					<use xlink:href="/assets/icons.svg#unlock-keyhole"></use>
				</svg>
			</button>
		</div>
	</div>
</ng-template>

<ng-template #doctorNavLinks>
	<a *transloco="let t; prefix: 'header'" class="nav-link text-decoration-none" routerLink="/clinic">
		{{ t("clinicnavtitle") }}
	</a>
</ng-template>

<ng-template #patientNavLinks>
	<a *transloco="let t; prefix: 'header'" class="nav-link text-decoration-none" routerLink="/profile">
		{{ t("profilenavtitle") }}
	</a>
</ng-template>